import React, {useEffect} from 'react';
import useState from "react-usestateref";
import Header from './Header';
import Sidebar from './Sidebar';
import ReactPaginate from 'react-paginate';
import apiService from "../core/sevice/detail";
import { getMethod, postMethod } from "../core/sevice/common.api";
import moment from "moment";
import {socket} from "../core/context/socket";
import toast, { Toaster }  from "react-hot-toast";
import * as XLSX from 'xlsx';
import LINEAR_BG from "../assets/compress/linear-bg-primary.webp";
import LAST from "../assets/compress/profit-icon.webp";

function Profit() {
    
    const [isLoading,setIsLoading,isLoadingref] = useState(false);
    const [TotalPages, setTotalPages,TotalPagesref] = useState(0);
    const [search,setsearch,searchref] = useState("");

    const [search_trade,setsearch_trade,search_traderef] = useState("");
    const [tradeOrders,settradeOrders,tradeOrdersref] = useState([]);
    const [TotalPages_trade, setTotalPages_trade,TotalPages_traderef] = useState(0);

    const [startDate, setstartDate, startDateref] = useState("");

    const [endDate, setendDate, endDateref] = useState("");
    const [alltradeHistory,setalltradeHistory,alltradeHistoryref] = useState([]);

    useEffect(() => {
        getTradeHistory(1);
      }, [0])

    const setfilterDate = async (val, type) => {
        if(type== "start")
        {
           setstartDate(val);
        }
        else
        {
           setendDate(val);
        }
        console.log("date value",val);
        if(val != "")
        {
          getTradeHistory_filter(1);
        }
        else
        {
          getTradeHistory(1);
        }
     };


     const getTradeHistory = async (currentPage) => {
       let count = currentPage == undefined ? 1 : currentPage;
       try {
         var payload = {
           perPage: 10,
           page: count,
           search: search_traderef.current,
           startdate: startDateref.current,
           enddate: endDateref.current
         }
         var data = {
           apiUrl: apiService.getProfit_triangular,
           payload: payload
         };
         setIsLoading(true);
         var resp = await postMethod(data);
         console.log("trade history resp",resp);
         var order_resp = resp.data;
         setIsLoading(false);
         if (order_resp.status == true) {
          var profit_data = [];
          if(order_resp.result.length > 0)
          {
           
            var resp_data = order_resp.result;
             for(var i=0; i<resp_data.length; i++)
             {
                // if(resp_data[i].profit > 0)
                // {
                    var buy_total = +resp_data[i].entry_total;
                    var sell_total = +resp_data[i].exit_total;
                    var profit_percentage = (+resp_data[i].profit / buy_total) * 100;
                    var obj = {
                        pair1: resp_data[i].pair_first,
                        pair2: resp_data[i].pair_second,
                        pair3: resp_data[i].pair_third,
                        entry_total: parseFloat(buy_total).toFixed(2),
                        exit_total: parseFloat(sell_total).toFixed(2),
                        profit_amount: parseFloat(+resp_data[i].profit).toFixed(2),
                        profit_percentage: parseFloat(+profit_percentage).toFixed(2),
                        strategy: "Triangular",
                        date: moment(resp_data[i].createdAt).format("lll")
                    }
    
                    profit_data.push(obj);
                // }
               
             }
          }
           settradeOrders(profit_data);
           setTotalPages_trade(order_resp.pages);
         }
       } catch (error) {
         setIsLoading(false);
       }
     }
   
     const handlePageClick_trade = async (data) => {
       console.log(data.selected);
       let currentPage = data.selected + 1;
       getTradeHistory(currentPage);
     };


     const getTradeHistory_filter = async (currentPage) => {
        socket.off("GetProfitOrders_user");
        let count = currentPage == undefined ? 1 : currentPage;
        try {
          var payload = {
            perPage: 10,
            page: count,
            search: search_traderef.current,
            startdate: startDateref.current,
            enddate: endDateref.current
          }
          var data = {
            apiUrl: apiService.getProfit_triangular,
            payload: payload
          };
          setIsLoading(true);
          var resp = await postMethod(data);
          console.log("trade history resp",resp);
          var order_resp = resp.data;
          setIsLoading(false);
          if (order_resp.status == true) {
           var profit_data = [];
           if(order_resp.result.length > 0)
           {
            
             var resp_data = order_resp.result;
              for(var i=0; i<resp_data.length; i++)
              {
                var buy_total = +resp_data[i].entry_total;
                var sell_total = +resp_data[i].exit_total;
                var profit_percentage = (+resp_data[i].profit / buy_total) * 100;
                var obj = {
                    pair1: resp_data[i].pair_first,
                    pair2: resp_data[i].pair_second,
                    pair3: resp_data[i].pair_third,
                    entry_total: parseFloat(buy_total).toFixed(2),
                    exit_total: parseFloat(sell_total).toFixed(2),
                    profit_amount: parseFloat(+resp_data[i].profit).toFixed(2),
                    profit_percentage: parseFloat(+profit_percentage).toFixed(2),
                    strategy: "Triangular",
                    date: moment(resp_data[i].createdAt).format("lll")
                }
 
                 profit_data.push(obj);
              }
           }
            settradeOrders(profit_data);
            setTotalPages_trade(order_resp.pages);
          }
        } catch (error) {
          setIsLoading(false);
        }
      }

      const handleChange = (e) => {
        try {
          const sanitizedValue = e.target.value.replace(/\s/g, "");
          console.log(sanitizedValue, "-=-sanitizedValue=-=");
          setsearch_trade(sanitizedValue);
          // setsearch(e.target.value);
          searchTradeOrders();
        } catch (error) {}
      };
      
     const searchTradeOrders = async () => {
        console.log("search_traderef",search_traderef.current);
        if(search_traderef.current != "")
        {
          getTradeHistory_filter(1);
        }
        else
        {
          getTradeHistory(1);
        }
     };

      const downloadData = async () => {
        try {
            var data = {
                apiUrl: apiService.getalltradehistory_triangular,
              };
              var resp = await getMethod(data);
              console.log(resp,"resprespresprespresp");
              if (resp.status == true){
                setalltradeHistory(resp.data);
                var profit_data = [];
                if(resp.data.length > 0)
                {
                 
                  var resp_data = resp.data;
                   for(var i=0; i<resp_data.length; i++)
                   {
                     var buy_total = +resp_data[i].entry_total;
                     var sell_total = +resp_data[i].exit_total;
                     var profit_percentage = (+resp_data[i].profit / buy_total) * 100;
                     var obj = {
                         'Pair1': resp_data[i].pair_first,
                         'Pair2': resp_data[i].pair_second,
                         'Pair3': resp_data[i].pair_third,
                         'Entry Total': parseFloat(buy_total).toFixed(2),
                         'Exit Total': parseFloat(sell_total).toFixed(2),
                         'Profit': parseFloat(+resp_data[i].profit).toFixed(2),
                         'Profit %': parseFloat(+profit_percentage).toFixed(2),
                         'Strategy': "Triangular",
                         'Date': moment(resp_data[i].createdAt).format("lll")
                     }
      
                      profit_data.push(obj);
                   }
                }
                const fieldsToExport = ['Pair1', 'Pair2','Pair3','Entry Total', 'Exit Total','Profit','Profit %','Strategy','Date'];
                  console.log("Admin Details:", profit_data);
                  const filteredData = profit_data.map(item => {
                    const filteredItem = {};
                    fieldsToExport.forEach(field => {
                      filteredItem[field] = item[field];    
                    });
                    console.log("Filtered Item:", filteredItem);
                      return filteredItem;
                  })
                  console.log("Filtered Data:", filteredData);
                  const worksheet = XLSX.utils.json_to_sheet(filteredData);
                  const workbook = XLSX.utils.book_new();
                  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                  XLSX.writeFile(workbook, 'TradeHistory.xlsx');
            
                  toast.success("File Downloaded")
              }
        } catch (error) {
          
        }
      }

  return (
    <>
      <section>
        <Header />
      </section>

      <div className="container-fluid enzo-wrapper">
        <div className="row ">
          <div className="col-lg-2 pad-left-0 max-md-none bor-right max-d-none">
            <Sidebar />
          </div>

          <div className="col-lg-10 pad-left-0 mar-bot">
            <div className="dashboard_content">
              <img src={LINEAR_BG} alt="linear-bg" />
            </div>
            <div className="amt-grid">
              <div className="auto-bot-wrapper profit-mar-top">
                <div className="auto-top profit-top bor-bottom ">
                  <div className="d-flex gap-3 align-items-center">
                    <img
                      src={LAST}
                      alt="balance-history"
                      className="ref-profit-img"
                    />
                    <span className="ref-profit">Profit</span>
                  </div>
                  <div className="profit-right-search">
                    <div className="profit-filter">
                      <div className="order-from">
                        <span className="order-from-fil">From </span>
                        <input
                          type="date"
                          placeholder="from"
                          className="order-from-inp"
                          onChange={(e) =>
                            setfilterDate(e.target.value, "start")
                          }
                        />
                      </div>
                      <div className="order-from">
                        <span className="order-from-fil">To </span>
                        <input
                          type="date"
                          placeholder="to"
                          className="order-from-inp"
                          onChange={(e) => setfilterDate(e.target.value, "end")}
                        />
                      </div>
                    </div>
                    <div className="profit-search-wrapper">
                      <input
                        type="text"
                        placeholder="Search"
                        // onChange={(e) => setsearch_trade(e.target.value)}
                        onChange={handleChange}
                      />
                      <span>
                        <i
                          class="fa-solid fa-magnifying-glass"
                          onClick={searchTradeOrders}
                        ></i>
                      </span>
                    </div>
                    <div className="profit-download-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-6"
                        onClick={downloadData}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="auto-table">
                <div className="table-container">
                <table>
                    <thead>
                    <tr className="profit-thead-row">
                        <th>Pair1</th>
                        <th>Pair2</th>
                        <th>Pair3</th>
                        <th>Entry Total (USDT)</th>
                        <th>Exit Total (USDT)</th>
                        <th>Profit (USDT)</th>
                        <th>Profit (%)</th>
                        <th>Strategy</th>
                        <th>Date</th>
                    </tr>
                    </thead>
                    <tbody>
                        {isLoadingref.current == true ? (
                            <>
                            <tr className="text-center">
                                <td colSpan={9}>
                                <div className="loader-css">
                                <img
                                src={require("../assets/loader.gif")}
                                alt="loader"
                                className="loader-gif"
                                />
                                </div>
                                </td>
                            </tr>
                            
                            </>
                            ):(
                            <>
                            {tradeOrdersref.current.length > 0 ? (
                            tradeOrdersref.current.map((element, index) => {
                                var strategy = (element.strategy == "intra" || element.strategy == "dca") ? "Intra": element.strategy;
                            return (
                            <>
                            <tr className="profit-tbody-row">
                                <td>{element.pair1}
                                </td>
                                <td>{element.pair2}
                                </td>
                                <td>{element.pair3}
                                </td>

                                <td>{element.entry_total}
                                </td>
                                <td>{element.exit_total}
                                </td>
                                <td>{element.profit_amount}
                                </td>
                                <td>{element.profit_percentage}
                                </td>
                                <td>{strategy}
                                </td>
                                <td>{element.date}
                                </td>
                                </tr>
                                </>
                                )
                                })) : (
                                    <tr>
                                    <td colSpan={9} className="text-center py-5">
                                        <div className="empty_data">
                                        <div className="empty_data_img">
                                            <img
                                            src={require("../assets/No-data.webp")}
                                            width="100px"
                                            />
                                        </div>
                                        <div className="no_records_text">
                                            No Records Found
                                        </div>
                                        </div>
                                    </td>
                                    </tr>
                                )}
                                </>
                            )}
                        
                        {tradeOrdersref.current.length > 0 ? (
                        <tr className='text-center text-white pagi_Btm_borno'>
                        <td colSpan="12">
                            <div className="paginationcss">
                                <ReactPaginate
                                    previousLabel={"<"}
                                    nextLabel={">"}
                                    breakLabel={"**"}
                                    pageCount={TotalPages_traderef.current}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={0}
                                    onPageChange={handlePageClick_trade}
                                    containerClassName={"pagination pagination-md justify-content-center"}
                                    pageClassName={"page-item"}
                                    pageLinkClassName={"page-link"}
                                    previousClassName={"page-item"}
                                    previousLinkClassName={"page-link"}
                                    nextClassName={"page-item"}
                                    nextLinkClassName={"page-link"}
                                    breakClassName={"page-item"}
                                    breakLinkClassName={"page-link"}
                                    activeClassName={"active"}
                                />
                            </div>
                        </td>
                    </tr>
                        ) : ("")} 
                </tbody>
                </table>
                </div>
                </div>

            </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Profit;